module.exports = __webpack_public_path__ + "img/home-computer.99127b59.png";